import script from "./EPeriodontalMapTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./EPeriodontalMapTable.vue?vue&type=script&lang=ts&setup=true"

import "./EPeriodontalMapTable.vue?vue&type=style&index=0&id=32be87be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32be87be"]])

export default __exports__